import React, { useState } from 'react';
import SideNavigationBar from '../components/SideNavigationBar';
import {
	Grid,
	TextField,
	IconButton as IconBtn,
	Typography,
	List,
	ListItem,
	CircularProgress,
} from '@mui/material';
import { useMainCustomStyle } from '../assets/theme/Theme';
import IconButton from '../components/IconButton';
import {
	EnhanceIcon,
	RefreshIcon,
	SmallClipBoardIcon,
} from '../assets/icons/Icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { sendNoteToEnhance } from '../services/CarePlanServices';

function CreateCareNote() {
	const mainDivStyle = useMainCustomStyle();
	const [userNote, setUserNote] = useState('');
	const [enhancedNote, setEnhancedNote] = useState('');
	const [enhanceCount, setEnhanceCount] = useState(2);
	const [isNoteEnhanced, setIsNoteEnhanced] = useState(false);
	const [isEnhanceBtnDisabled, setIsEnhanceBtnDisabled] = useState(false);
	const [isSuggestionForNote, setIsSuggestionForNote] = useState(false);
	const [suggestions, setSuggestion] = useState([]);
	const [userNoteError, setUserNoteError] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	async function getEnhanceNote(note) {
		setIsLoading(true);

		const body = {
			care_note: note,
		};

		const data = await sendNoteToEnhance(body);

		if (data.enhanced_care_note) {
			setEnhancedNote(data.enhanced_care_note);
			if (data.suggestions) {
				const suggestionsText = data.suggestions.map(
					item => item.suggestion,
				);
				setSuggestion(suggestionsText);
				setIsSuggestionForNote(true);
			}
			setIsNoteEnhanced(true);
			setIsEnhanceBtnDisabled(true);
		} else {
			toast.error(data.message);
		}

		setIsLoading(false);
	}

	function getNoteForUserNote() {
		if (!userNote || userNote === '') {
			setUserNoteError('Please enter the note');
			return;
		}

		getEnhanceNote(userNote);
	}

	function getNoteForEnhancedNote() {
		if (enhanceCount !== 0) {
			getEnhanceNote(enhancedNote);
			setEnhanceCount(enhanceCount - 1);
		} else {
			toast.warn('Note: You can refresh the enhanced note 2 times.');
		}
	}

	function inCopyEnhancedNote() {
		if (navigator.clipboard) {
			navigator.clipboard.writeText(enhancedNote);
		} else {
			const tempTextArea = document.createElement('textarea');
			tempTextArea.value = enhancedNote;
			document.body.appendChild(tempTextArea);
			tempTextArea.select();
			document.execCommand('copy');
			document.body.removeChild(tempTextArea);
		}
	}

	function renderEnchantmentView() {
		if (isLoading) {
			return (
				<Grid
					container
					alignItems={'center'}
					height={'360px'}
					justifyContent={'center'}>
					<CircularProgress sx={{ color: '#28696D' }} />
				</Grid>
			);
		} else {
			return (
				<>
					<TextField
						multiline
						sx={{
							'& fieldset': { border: 'none' },
							width: '100%',
							height: '300px',
						}}
						rows={12}
						value={enhancedNote}
						onChange={event => setEnhancedNote(event.target.value)}
					/>
					{isNoteEnhanced && (
						<Grid container justifyContent={'flex-end'}>
							<IconBtn
								onClick={getNoteForEnhancedNote}
								style={{ padding: '0px', marginRight: '10px' }}>
								<RefreshIcon />
							</IconBtn>
							<IconButton
								Icon={SmallClipBoardIcon}
								text={'Copy'}
								onClick={inCopyEnhancedNote}
							/>
						</Grid>
					)}
				</>
			);
		}
	}

	return (
		<>
			<SideNavigationBar />
			<div style={mainDivStyle}>
				<Grid
					container
					paddingLeft={{ xs: '0px', md: '20px', sm: '20px' }}
					paddingBottom={'10px'}
					paddingRight={'20px'}>
					<Grid item style={{ paddingLeft: '30px' }}>
						<Typography
							variant="h6"
							fontWeight={'600'}
							color="#28696D">
							Enhance Care Note
						</Typography>
					</Grid>
					<Grid container paddingLeft={'30px'} paddingTop={'20px'}>
						<Grid
							item
							sm={6}
							xs={12}
							width={'40%'}
							border={'1px solid #D9D9D9'}
							bgcolor={'#FFFFFF'}
							borderRadius={'5px 0px 0px 5px'}
							padding={'10px'}
							height={'360px'}>
							<TextField
								placeholder="Type the note..."
								multiline
								sx={{
									'& fieldset': { border: 'none' },
									width: '100%',
									height: '300px',
								}}
								onChange={event => {
									setUserNote(event.target.value);
									setUserNoteError('');
									setIsEnhanceBtnDisabled(false);
									setEnhanceCount(2);
								}}
								rows={12}
							/>
							<Grid
								container
								justifyContent={'space-between'}
								alignItems={'center'}>
								<Typography
									variant="body2"
									paddingX={'10px'}
									color={'red'}>
									{userNoteError}
								</Typography>
								<IconButton
									Icon={EnhanceIcon}
									text={'Enhance'}
									onClick={getNoteForUserNote}
									disabled={isEnhanceBtnDisabled}
								/>
							</Grid>
						</Grid>
						<Grid
							item
							sm={6}
							xs={12}
							width={'45%'}
							border={'1px solid #D9D9D9'}
							bgcolor={'#FFFFFF'}
							borderRadius={'0px 5px 5px 0px'}
							padding={'10px'}
							height={'360px'}>
							{renderEnchantmentView()}
						</Grid>
					</Grid>
					{isSuggestionForNote && (
						<Grid
							container
							bgcolor={'#FFFFFF'}
							flexDirection={'column'}
							marginLeft="30px"
							padding="20px"
							marginTop="10px">
							<Typography
								variant="h6"
								fontWeight={'600'}
								color="#28696D">
								Suggestion
							</Typography>
							<List sx={{ listStyle: 'disc', pl: 4 }}>
								{suggestions.map((text, index) => {
									return (
										<ListItem
											key={index}
											sx={{ display: 'list-item' }}>
											<Typography>{text}</Typography>
										</ListItem>
									);
								})}
							</List>
						</Grid>
					)}
				</Grid>
			</div>
		</>
	);
}

export default CreateCareNote;
